import firebase from "firebase/app";
import "firebase/auth";

import { PlatformFirebase } from "../../../common/libraries/firebase/cloud/firebase/platform-firebase";

PlatformFirebase.auth.Auth.Persistence = firebase.auth.Auth.Persistence;
